import workspaceQuery from 'graphql/queries/nominal/NominalAccrualPrepaymentWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/nominal/NominalAccrualPrepaymentQuery.graphql';
import defaultQuery from 'graphql/queries/nominal/NominalAccrualPrepaymentDefault.graphql';
import mutationQuery from 'graphql/mutations/nominal/NominalAccrualPrepaymentMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/nominal/SaveNominalAccrualPrepaymentTempMutation.graphql';
import fragment from 'graphql/fragments/nominal/NominalAccrualPrepaymentFragment.graphql';
import aggregateQuery from 'graphql/queries/nominal/NominalAccrualPrepaymentAggregateQuery.graphql';

import { formActions } from 'actions/nominal/NominalAccrualPrepaymentAction';

const NominalAccrualPrepayment = {
  type: 'NominalAccrualPrepayment',
  title: 'Nominal Accruals & Prepayments',
  formUrl: '/Nominal/AccrualPrepayment/Details/',
  formTitle: 'Accruals & Prepayments',
  workspaceUrl: '/Nominal/AccrualPrepayment/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'NOMINAL_ACCRUAL',
  actions: formActions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED', 'PENDING'],
    },
  ],
};

export default NominalAccrualPrepayment;
